export default __webpack_public_path__ + "static/media/mentor-banner.063e39db.png";